<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\AbnormalClockin\viewAbnormalClockin.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-28 15:10:46
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_abnormalClockin_form_title')"
    backgroundClass="transparent"
    widthClass="max-1000"
    pad="0"
    :editBtn="!iSEdited && Number(approval_status) === 0 && false"
    :initData="{}"
    @edit="iSEdited = true"
    @change="(changed) => (isChanged = changed)"
    :checkData="[]"
  >
    <!-- content -->
    <template v-slot:page-main v-if="Data">
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/abnormal-clock-in/detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{
                $t("label_essweb_abnormalClockin_form_swiftNumberLabel")
              }}</v-sheet
            >
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="$t('label_essweb_abnormalClockin_form_swiftNumberLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_submitDateLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="$t('label_essweb_abnormalClockin_form_submitDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">
              {{
                $t("label_essweb_abnormalClockin_form_applicatLabel")
              }}</v-sheet
            >
            <v-autocomplete
              single-line
              v-model="user"
              readonly
              :items="users"
              append-icon
              item-value="uuid"
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="data">
                <v-chip pill v-bind="data.attrs" :input-value="data.selected">
                  <StaffAvatar
                    left
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />
                  {{ $getCommonLangValue(data.item.preferred_name) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </Section>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_punchDateLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.punch_utc_datetime, 'YYYY/MM/DD')"
              :label="$t('label_essweb_abnormalClockin_form_punchDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_actualPunchTimeLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.punch_utc_datetime, 'HH:mm')"
              :label="
                $t('label_essweb_abnormalClockin_form_actualPunchTimeLabel')
              "
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
      <Section>
        <v-container fluid class="pa-0 ma-0 d-flex flex-row">
          <v-container fluid class="pa-0 ma-0 flex-shrink-1" style="width: 45%">
            <v-sheet class="text-subtitle-1">{{
              $t("label_essweb_abnormalClockin_form_failItemIitleLabel")
            }}</v-sheet>
            <v-sheet
              class="my-2 d-flex align-center flex-row"
              v-if="!Number(Data.gps_criteria_matched)"
            >
              <svg-icon
                size="24"
                fill="transparent"
                :iconClass="'Alert'"
              /><span class="text-body-2 px-2">{{
                $t("label_essweb_abnormalClockin_form_punchtype_GPSLabel")
              }}</span>
            </v-sheet>
            <v-sheet
              class="my-2 d-flex align-center flex-row"
              v-if="!Number(Data.wifi_criteria_matched)"
            >
              <svg-icon
                size="24"
                fill="transparent"
                :iconClass="'Alert'"
              /><span class="text-body-2 px-2">{{
                $t("label_essweb_abnormalClockin_form_punchtype_WiFiLabel")
              }}</span>
            </v-sheet>
            <v-sheet
              class="my-2 d-flex align-center flex-row"
              v-if="!Number(Data.bluetooth_criteria_matched)"
            >
              <svg-icon
                size="24"
                fill="transparent"
                :iconClass="'Alert'"
              /><span class="text-body-2 px-2">{{
                $t("label_essweb_abnormalClockin_form_punchtype_BluetoothLabel")
              }}</span>
            </v-sheet>
          </v-container>
          <v-container
            fluid
            class="
              pa-0
              ma-0
              flex-grow-1
              rounded-lg
              mrc-border-solid
              scroll_content_no
            "
            style="position: relative"
          >
            <GmapMap
              :center="center"
              :zoom="18"
              ref="abnormalMap"
              :options="{
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                keyboardShortcuts: false,
                gestureHandling: 'greedy',
                fullscreenControl: false,
                disableDefaultUi: false,
              }"
              map-type-id="roadmap"
              style="width: 100%; height: 600px"
            >
              <GmapMarker
                :option="{ animation: 'drop', shape: 'circle' }"
                :position="markers"
                :icon="makericon"
                :clickable="true"
                :draggable="false"
                @click="setCenter(markers)"
              />
            </GmapMap>
          </v-container>
        </v-container>
      </Section>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12" v-if="Data.attachments">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_attachmentLabel") }}
            </v-sheet>
            <ImgDragUpdate :defaultImageList="Data.attachments" disabled />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_reasonLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              v-model="Data.invalid_reason_text"
              :label="$t('label_essweb_abnormalClockin_form_reasonLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_abnormalClockin_form_messageLabel") }}
            </v-sheet>
            <v-text-field
              readonly
              v-model="Data.remarks"
              :label="$t('label_essweb_abnormalClockin_form_messageLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
    </template>
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
      />
    </template>
  </ContentLayout>
</template>
<script>
import makericon from "@/assets/AttendancePoint.png";
// import makericon from "@/assets/place.png";
import { mapGetters } from "vuex";
import { gmapApi } from "vue2-google-maps";

export default {
  name: "viewAbnormalClockin",
  computed: {
    ...mapGetters(["AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
  },
  data() {
    return {
      Data: { attachments: [] },
      users: [],
      isChanged: false,
      user: null,
      google: null,
      approval_status: 1,
      iSEdited: false,
      makericon: makericon,
      page_params: null,
      markers: null,
      center: { lat: 0, lng: 0 },
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.getDetail();
    const that = this;
    if (
      this.curAppInfo["user"]["latitude"] != undefined &&
      this.curAppInfo["user"]["longitude"] != undefined
    ) {
      this.center = {
        lat: Number(this.curAppInfo["user"]["latitude"]),
        lng: Number(this.curAppInfo["user"]["longitude"]),
      };
    }
    this.$gmapApiPromiseLazy().then(() => {
      that.google = new gmapApi();
    });
  },
  methods: {
    toSave() {},
    setCenter: function (position) {
      const that = this;
      this.$refs.abnormalMap.$mapPromise.then((map) => {
        map.setCenter(position);
        that.center = position;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_record_application",
        url: "/punch_invalid_record_application/get-punch_invalid_record_application-details/",
        data: { uuid: this.page_params.id },
      }).then((res) => {
        that.approval_status = res.data.approval_status;
        that.markers = {
          lat: Number(res.data.latitude),
          lng: Number(res.data.longitude),
        };
        that.center = {
          lat: Number(res.data.latitude),
          lng: Number(res.data.longitude),
        };
        that.setCenter(that.center);
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        if (res.data["attachments"]) {
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        } else {
          res.data["attachments"] = [];
        }
        that.Data = res.data;
      });
    },
  },
};
</script>
